module.exports = __webpack_public_path__ + "img/Joseph.ba326228.png";